(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slideshow-auto"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const slideshows = document.querySelectorAll('.slideshow');

  slideshows.forEach(slideshow => {
    const slides = slideshow.querySelectorAll('.slide');
    const link = slideshow.querySelector('.slideshow-link');
    const speed = parseInt(slideshow.dataset.speed) || 3000;
    const urls = JSON.parse(slideshow.dataset.urls);
    let current = 0;

    setInterval(() => {
      slides[current].classList.remove('active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('active');
      link.href = urls[current];
    }, speed);
  });
});
  } catch(e) { console.error(e); }
})();

})();
